"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var context_1 = require("../../context");
function FormattedAddress(_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    var lines = ['line_1', 'line_2', 'line_3', 'town', 'region', 'country', 'postcode'];
    var address = lines.map(function (li) {
        if (client[li] && client[li].length > 0) {
            return client[li];
        }
        return false;
    });
    var addressLines = address.filter(Boolean);
    if (addressLines.length > 0) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            addressLines.map(function (li, index) { return (react_1.default.createElement("p", { className: "mb-0", key: "line-" + index }, li)); }),
            client.address_map_link && (react_1.default.createElement("div", { className: "mt-2" },
                react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: client.address_map_link }, "View on a map")))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, trans('optiiva::misc.empty-line'));
}
exports.default = FormattedAddress;
//# sourceMappingURL=FormattedAddress.js.map